<template>
  <div class="container">
    <!-- 下层轮播 -->
    <div class="banner">
      <el-carousel height="100vh" :interval="6000">
        <el-carousel-item>
          <img src="https://www.yunhai-crm.com/resource-file/yunhai/guanwang/changan/background1.png" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="https://www.yunhai-crm.com/resource-file/yunhai/guanwang/changan/background2.png" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 上层板块 -->
    <div class="content">
      <audio ref="audio" style="display: none;" autoplay loop>
        <source src="../../../public/music/music.mp3" type="audio/mpeg">
      </audio>
      <header>
        <img class="code" v-if="isPlay" @click="isShowQRcode" src="../../../public/icons/music.png" alt="">
        <img class="code" v-else @click="isShowQRcode" src="../../../public/icons/paused.png" alt="">
        <div class="QRcode" v-if="showQRcode"></div>
        <div class="title">
          <img src="../../../public/images/title.png" alt="">
        </div>
        <div class="nav">
          <ul @mouseenter="isShowNav">
            <li style="color: orange;">首页</li>
            <li>&emsp;导览&emsp;</li>
            <li>&emsp;公告&emsp;</li>
            <li>&emsp;荣誉&emsp;</li>
            <li>报名通道</li>
            <!-- <li>优秀作品</li> -->
            <li>成绩查询</li>
            <li>&emsp;关于&emsp;</li>
          </ul>
        </div>
      </header>
      <!-- 弹出子菜单 -->
      <transition name="fade">
        <div class="header_nav" v-show="showNav" @mouseleave="closeNav">
          <ul>
            <li>&emsp;&emsp;</li>
            <li>
              <div @click="toOrganize">组织机构</div>
              <div @click="toActive">活动项目</div>
              <div @click="toDemand">作品要求</div>
              <div @click="toProcess">活动流程</div>
            </li>
            <li>
              <div @click="toPoetry">诗词答题</div>
              <div @click="toCalligraphy">书法活动</div>
              <div @click="toArt">美术活动</div>
              <div @click="toRecite">朗诵活动</div>
              <div @click="toEssay">征文活动</div>
            </li>
            <li>
              <div @click="toActiveHonor">活动荣誉</div>
              <div @click="toHonor">荣誉实拍</div>
            </li>
            <li>
              <div @click="toSubmit">提交方式</div>
              <div @click="toContact">联系我们</div>
            </li>
            <!-- <li>
              <div @click="toNowTerm">本届佳作</div>
              <div @click="toBeforeTerm">往届佳作</div>
            </li> -->
            <li>
              <div><a href="http://www.yunhai-crm.com/changAnQuery">成绩查询</a></div>
            </li>
            <li>
              <div @click="toOverview">活动概述</div>
              <div @click="toMedia">媒体报道</div>
              <div @click="toExemption">免责须知</div>
            </li>
          </ul>
        </div>
      </transition>
      <!-- 主体内容 -->
      <div class="subject">
        <div class="edition">
          <div class="subjectTitle">
            <img src="../../../public/images/content_title.png" alt="">
          </div>
          <div class="subjectHeader">
            <div>
              <h3>征稿对象</h3>
              <h6>OBJECT OF SOLICITATION</h6>
              <p>面向全国（含港澳台）青少年以及全球华侨华人绘画、书法、朗诵、表演、征文、诗词、展演爱好者和成人艺术家征集艺术作品。
              </p>
              <div class="application" @click="toSubmit">
                <img src="../../../public/images/arrowhead.png" alt="">
                <div>快速报名活动</div>
              </div>
            </div>
            <div>
              <h3>活动组别</h3>
              <h6>ACTIVITY GROUF</h6>
              <ul class="activity">
                <li>
                  <div>学前组</div>
                  <div>(6岁以下)</div>
                </li>
                <li>
                  <div>小学低年级组</div>
                  <div>(7-9岁)</div>
                </li>
                <li>
                  <div>小学高年级组</div>
                  <div>(10-12岁)</div>
                </li>
                <li>
                  <div>初中组</div>
                  <div>(13-15岁)</div>
                </li>
                <li>
                  <div>高中组</div>
                  <div>(16-18岁)</div>
                </li>
                <li>
                  <div>青年组</div>
                  <div>(19岁-30岁)</div>
                </li>
                <li>
                  <div>成人组</div>
                  <div>(31-59岁)</div>
                </li>
                <li>
                  <div>高龄组</div>
                  <div>(60岁及以上)</div>
                </li>
              </ul>
              <!-- <div style="font-size: 16px; width: 100%;">注:全部参选作品将按照对应组别进行评审</div> -->
            </div>
            <div>
              <h3>组织机构</h3>
              <h6>ACTIVITY INTRODUCTION</h6>
              <div class="unit">
                <h4>主办单位</h4>
                <p>长安长安美育系列活动组委会<br>
                </p>
              </div>
              <div class="unit">
                <h4>支持单位</h4>
                <p>1.国家民族画院少儿美术发展中心<br>
                  2.中国智慧工程研究会国际教育交流工作委员会</p>
              </div>
            </div>
          </div>
          <!-- 基础信息 -->
          <div class="baseCorrelation">
            <img src="../../../public//images/baseMessage.png" alt="">
          </div>
          <!-- 活动相关 -->
          <div class="correlation">
            <img src="../../../public/images/activityCorrelation.png" @click="toActivityCorrelation" alt="">
          </div>
          <!-- 竞赛相关 -->
          <div class="correlation">
            <img src="../../../public/images/contestCorrelation.png" @click="toContestCorrelation" alt="">
          </div>
          <!-- 报名相关 -->
          <div class="correlation">
            <img src="https://www.yunhai-crm.com/resource-file/yunhai/guanwang/changan/registerCorrelation.png"
              @click="toRegisterCorrelation" alt="">
          </div>
          <div class="education">
            <img src="../../../public/images/education.png" alt="">
          </div>
          <div class="subjectFooter">
            <img src="https://www.yunhai-crm.com/resource-file/yunhai/guanwang/changan/footer.png" alt="">
          </div>
          <!-- 底部 -->
          <div class="footer">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../../components/Footer/Footer.vue'
export default {
  name: 'homes',
  data() {
    return {
      showNav: false,
      showQRcode: false,
      isPlay: true,//音乐是否在播放
    }
  },
  components: {
    Footer
  },
  methods: {
    isShowNav() {
      this.showNav = true;
    },
    closeNav() {
      this.showNav = false;
    },
    isShowQRcode() {
      if (this.isPlay) {
        this.$refs.audio.pause();
        this.isPlay = false // 设置播放状态
      } else {
        this.$refs.audio.play();
        this.isPlay = true; // 设置播放状态
      }
      // this.showQRcode = !this.showQRcode;
    },
    // 跳转
    toActivityCorrelation() {
      this.$router.push('/activityCorrelation');
    },
    toContestCorrelation() {
      this.$router.push('/contestCorrelation');
    },
    toRegisterCorrelation() {
      this.$router.push('/registerCorrelation');
    },
    toOrganize() {
      this.$router.push('/organize');
    },
    toActive() {
      this.$router.push('/active');
    },
    toDemand() {
      this.$router.push('/demand');
    },
    toProcess() {
      this.$router.push('/process');
    },
    toPoetry() {
      this.$router.push('/poetry');
    },
    toCalligraphy() {
      this.$router.push('/calligraphy');
    },
    toArt() {
      this.$router.push('/art');
    },
    toRecite() {
      this.$router.push('/recite');
    },
    toEssay() {
      this.$router.push('/essay');
    },
    toHonor() {
      this.$router.push('/honor');
    },
    toActiveHonor() {
      this.$router.push('/activeHonor');
    },
    toSubmit() {
      this.$router.push('/submit');
    },
    toContact() {
      this.$router.push('/contact');
    },
    toNowTerm() {
      this.$router.push('/nowTerm');
    },
    toBeforeTerm() {
      this.$router.push('/beforeTerm');
    },
    toMedia() {
      this.$router.push('/media');
    },
    toExemption() {
      this.$router.push('/exemption');
    },
    toOverview() {
      this.$router.push('/overview');
    },
    toScores() {
      this.$router.push('/scores');
    }
  },
}
</script>

<style scoped>
.container {
  width: 100%;
}

.code {
  position: absolute;
  right: 100px;
  top: 40px;
  z-index: 10;
  width: 30px;
  height: 25px;
}

.code:hover {
  cursor: pointer;
}

.QRcode {
  width: 10vw;
  height: 10vw;
  z-index: 10;
  position: absolute;
  top: 72px;
  right: 12px;
  background-size: 100% 100%;
  background-image: url('../../../public/images/background_code.png')
}

.banner {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
}

.banner img {
  width: 100vw;
  height: 100vh;
}

.content {
  position: absolute;
  width: 100%;
  height: 3500px;
  background-color: rgba(0, 0, 0, 0);
  z-index: 2;
  top: 0;
}

header {
  position: relative;
  width: 100%;
  height: 25vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.nav ul {
  display: flex;
  justify-content: space-between;
  width: 60vw;
  color: white;
  font-size: 20px;
}

.header_nav {
  width: 100%;
  display: flex;
  justify-content: center;
  min-height: 30vh;
  padding: 20px 0;
  background-size: 100% 100%;
  background-image: url("../../../public/images/background_nav.png");
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.header_nav ul {
  display: flex;
  justify-content: space-between;
  width: 60vw;
  color: white;
  font-size: 20px;
}

.header_nav ul li div {
  margin: 3vh 0;
}

/* .nav ul li:hover {
  color: orange;
  cursor: pointer;
} */

.header_nav ul li div:hover {
  color: orange;
  cursor: pointer;
}

.subject {
  width: 100%;
  position: absolute;
  top: 100vh;
  height: auto;
  background-size: 100% 100%;
  background-image: url('https://www.yunhai-crm.com/resource-file/yunhai/guanwang/changan/background_content.png');
}

/*********  主体部分 **********/
.edition {
  width: 100%;
  height: 93%;
  margin-top: 30vw;
}

.subjectTitle {
  text-align: center;
}

.subjectTitle img {
  width: 50%;
}

.subjectHeader {
  margin-top: 100px;
  display: flex;
  flex: 1;
  height: 400px;
  padding: 0 5%;
}

.subjectHeader div {
  width: 32%;
  padding: 0 5%;
  letter-spacing: 2px;
  box-sizing: border-box;
}

.subjectHeader div:nth-child(2) {
  border-left: 2px dashed rgb(160, 0, 0);
  border-right: 2px dashed rgb(160, 0, 0);
}

h3 {
  font-size: 25px;
}

p {
  width: 100%;
  margin-top: 50px;
  font-size: 20px;
  color: #333;
  letter-spacing: 3px;
  line-height: 50px;
  text-indent: 2em;
}

h4 {
  font-size: 21px;
  margin: 25px 0;
  font-weight: 600;
}

.unit {
  width: 100% !important;
  padding: 0 !important;
}

.unit p {
  text-indent: 0;
  margin-top: 0;
}

.activity {
  margin-top: 50px;
  padding: 0 10px;
  color: rgb(94, 51, 22);
}

.activity li {
  margin: 20px 0;
  display: flex;
  justify-content: space-around;
  font-size: 18px
}

.activity li div {
  border: none !important;
  padding: 0 10px !important;
}

.activity li div:first-child {
  width: 40%;
  text-align: justify;
}

.application {
  margin-top: 50px;
  display: flex;
  width: 100% !important;
  align-items: center;
  cursor: pointer;
}

.application div {
  font-size: 18px;
  border: none !important;
  padding: 0;
  margin-left: 30px !important;
}

.application img:hover {
  transform: scale(1.1);
  transition: transform 0.5s ease;
}

.baseCorrelation {
  margin-top: 260px;
  overflow: hidden;
}

.baseCorrelation img {
  width: 100%;
}

.correlation {
  padding: 30px 0;
  margin-top: 300px;
  overflow: hidden;
}

.correlation img {
  width: 100%;
  animation: zoom 8s infinite alternate;
  /* 动画名称、持续时间、循环方式 */
  cursor: pointer;
}

@keyframes zoom {
  0% {
    transform: scale(1);
    /* 初始大小 */
  }

  100% {
    transform: scale(1.05);
    /* 放大到1.2倍 */
  }
}

.education {
  margin-top: 150px;
  width: 100%;
  text-align: center;
}

.education img {
  width: 50%;
}

.subjectFooter {
  margin-top: 150px
}

.subjectFooter img {
  width: 100%;
}

/* 底部 */
.footer {
  width: 100%;
  height: 40vh;
}

/* 小屏幕/手机 */
@media screen and (max-width: 960px) {
  .code {
    right: 50px;
    top: 20px;
    width: 15px;
    height: 20px;
  }

  .banner img {
    height: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .content {
    position: absolute;
    width: 100%;
    height: 1000px;
    background-color: rgba(0, 0, 0, 0);
    z-index: 2;
    top: 0;
  }

  header {
    height: 25vh;
  }

  .nav ul {
    width: 95vw;
    font-size: 12px;
  }

  .header_nav ul {
    width: 95vw;
    font-size: 12px;
  }

  .edition {
    margin-top: 60vw;
  }

  .subjectTitle img {
    width: 80%;
  }

  .subjectHeader {
    height: auto;
    margin-top: 30px;
    padding: 0 5%;
    display: block;
  }

  .subjectHeader div {
    width: 100%;
    padding: 0 5%;
    letter-spacing: 2px;
    margin-right: 0px !important;
  }

  .subjectHeader>div:nth-child(2) {
    border: none;
    border-top: 2px dashed rgb(160, 0, 0);
    border-bottom: 2px dashed rgb(160, 0, 0);
    padding: 20px 5%;
    margin: 20px 0;
  }

  h3 {
    font-size: 14px;
  }

  p {
    margin-top: 20px;
    font-size: 13px;
    line-height: 20px;
    text-indent: 2em;
  }

  h4 {
    font-size: 16px;
    margin: 20px 0;
    font-weight: 600;
  }

  .activity {
    margin-top: 20px;
    padding: 0 10px;
    color: rgb(94, 51, 22);
  }

  .activity li {
    margin: 5px 0;
    font-size: 14px
  }

  .activity li div {
    border: none !important;
    padding: 0 10px !important;
  }

  .activity li div:first-child {
    width: 60vw;
    text-align: justify;
  }

  .application {
    margin-top: 20px;
    width: 100% !important;
  }

  .application div {
    font-size: 14px;
    border: none !important;
    padding: 0;
    margin-left: 20px !important;
  }

  .application img {
    width: 80px;
    height: 20px;
  }

  .baseCorrelation {
    margin-top: 20px;
    overflow: hidden;
  }

  .baseCorrelation img {
    width: 100%;
  }

  .correlation {
    padding: 30px 0;
    margin-top: 50px;
    overflow: hidden;
  }

  .education {
    margin-top: 50px;
    width: 100%;
    text-align: center;
  }

  .education img {
    width: 80%;
  }

  .subjectFooter {
    margin-top: 50px
  }

  .subjectFooter img {
    width: 100%;
  }

  /* 底部 */
  .footer {
    width: 100%;
    height: 40vh;
  }
}
</style>